module.exports = __webpack_public_path__ + "static/Drift-8065acb3e23a3d25fab54220f12d0e5a.png";